import { TextBox, TextBoxLayoutStyle } from '@apply/components';
import { useWizardDemoStore } from '../../../../../state/wizardDemoStore';

export const StreetAddressField = () => {
    const value = useWizardDemoStore((state) => state.property.streetAddress);
    const updateProperty = useWizardDemoStore((state) => state.updateProperty);

    return (
        <TextBox
            id='propertyStreetAddress'
            value={value}
            onChange={(streetAddress) => updateProperty({ streetAddress })}
            label='Street Address'
            required={true}
            width={'100%'}
            layoutStyle={TextBoxLayoutStyle.Horizontal}
            height='36px'
        />
    );
};
